/*
         * @ngdoc function
         * @name ePay.WebApi:Session_ErrorHandlerWebApi
         * @description
         * Web Api Service
         */
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams} from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { Session_ErrorHandlerModel } from '../../Models/Model/Session_ErrorHandlerModel';

@Injectable()
export class Session_ErrorHandlerWebApi {
	constructor(private http: HttpClient) { }


  logError(session_ErrorHandlerModel: Session_ErrorHandlerModel) {
		let headers = new HttpHeaders();
		let urlParams = new HttpParams();
		headers.append('Content-Type', 'application/json');
		return this.http.post<Session_ErrorHandlerModel>('/api/Session_ErrorHandler/LogError', session_ErrorHandlerModel, {headers: headers, params: urlParams})
	}

}
